/*
 * @Author: chengyu
 * @Date: 2022-10-13 15:29:45
 * @Description: 天启埋点
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ampLogKey, getAPM, getGaoConfig, getLbsConfig, getUBT, } from '../config';
import { ServiceTypeEnum } from '../enums';
import { MapRgcStatusEnum } from '../enums/ubt';
import { isArray, isFunction, isNumber, isObject, isString } from './is';
import { mapError, mapLog } from './logger';
import { JsonStringify } from './index';
/**
 * 网络监控
 * @param request
 */
export function trackHttp(request) {
    try {
        var APM = getAPM();
        if ((APM === null || APM === void 0 ? void 0 : APM.trackHttp) && isFunction(APM.trackHttp)) {
            APM.trackHttp(request);
        }
    }
    catch (e) {
        mapError('网络监控上报失败', e);
    }
}
/**
 * 异常捕获
 */
export function sendError(error) {
    try {
        var APM = getAPM();
        if ((APM === null || APM === void 0 ? void 0 : APM.sendError) && isFunction(APM.sendError)) {
            APM.sendError(error);
        }
    }
    catch (e) {
        mapError('天启异常捕获上报失败', e);
    }
}
/**
 * 天启 Log 日志埋点
 * https://hellobike.yuque.com/gzxsb9/gdvwvw/itybxd#D9QHc
 */
export function apmLog(e) {
    var _a;
    try {
        var APM = getAPM();
        if ((APM === null || APM === void 0 ? void 0 : APM.log) && isFunction(APM.log)) {
            APM.log({
                key: ampLogKey,
                value: JSON.stringify({
                    request: ((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.request) || '',
                    /**
                     * `fetchData`是经过`transformResponse`的结果
                     */
                    response: (e === null || e === void 0 ? void 0 : e.fetchData) || '',
                    error: (e === null || e === void 0 ? void 0 : e.name) || '',
                    errorMsg: (e === null || e === void 0 ? void 0 : e.message) || '',
                }),
            });
        }
    }
    catch (e) {
        mapError('天启自定义埋点异常', e);
    }
}
/**
 * 逆地理编码埋点
 * https://target.hellobike.cn/#/buryingManager/pageModule/details?id=4505&eventType=customize
 */
export function ubtRgcStatistics(opt) {
    try {
        var ubt = getUBT();
        var endTime_1 = new Date().getTime();
        var getHlErrorCode = function () {
            var _a, _b;
            if (opt.response && opt.response.data) {
                // 自研失败
                if (opt.type === ServiceTypeEnum.HELLO &&
                    MapRgcStatusEnum.lbsError === opt.status) {
                    return (_b = (_a = opt.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.infoCode;
                }
            }
        };
        var getGdErrorCode = function () {
            var _a, _b;
            if (opt.response && opt.response.data) {
                // 高德失败
                if (opt.type === ServiceTypeEnum.GAODE &&
                    MapRgcStatusEnum.gaodeSuccess !== opt.status) {
                    return (_b = (_a = opt.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.infoCode;
                }
            }
        };
        var getRt = function (start) {
            if (isNumber(start)) {
                return endTime_1 - start;
            }
            return 0;
        };
        if (ubt) {
            var sendBody = {
                // 标识是lbs sdk发起的逆地理请求
                // `customEventWithPointId`不支持自定义`eventId`
                eventId: 'map_api_reGeoCodingSearch',
                pointId: 'triggerExpose_Map_Rgc_Statistics',
                categoryId: 'platform',
                businessInfo: {
                    // LBS响应时长
                    LBSRT: getRt(opt.lbsStartTime),
                    // 高德接口响应时长
                    GDRT: getRt(opt.gaodeStartTime),
                    rt: getRt(opt.startTime),
                    Appkey: opt.appKey,
                    ResponseInfo: JsonStringify(opt.response),
                    RequestInfo: JsonStringify(opt.params),
                    status: opt.status,
                    /**
                     * 自研错误码
                     */
                    HlErrorCode: getHlErrorCode(),
                    /**
                     * 高德错误码
                     */
                    GdErrorCode: getGdErrorCode(),
                    ApiName: 'reGeoCodingSearch',
                },
            };
            // 兼容一下天启自定义埋点的新旧方法
            if (isFunction(ubt.customEventWithPointId)) {
                ubt.customEventWithPointId(sendBody);
            }
            else if (isFunction(ubt.customEvent)) {
                ubt.customEvent(sendBody);
            }
        }
    }
    catch (e) {
        mapError('ubt 上报异常', e);
    }
}
function getErrorCode(response) {
    if (isObject(response)) {
        var infoCode = response.infoCode;
        if (isObject(response.data)) {
            infoCode = response.data.infoCode;
        }
        return infoCode == null ? '' : "".concat(infoCode);
    }
    return '';
}
function getStartTime(type) {
    return function (_a) {
        var startTime = _a.startTime, fetchOptions = _a.fetchOptions, context = _a.context;
        var serviceType = fetchOptions.serviceType;
        var prevServiceType = context.prevServiceType, prevStartTime = context.prevStartTime;
        if (serviceType === type) {
            return "".concat(startTime || 0);
        }
        if (prevServiceType === type) {
            return "".concat(prevStartTime || 0);
        }
        return '0';
    };
}
var getStartTimeGaode = getStartTime(ServiceTypeEnum.GAODE);
var getStartTimeHello = getStartTime(ServiceTypeEnum.HELLO);
/**
 * 地图服务(LBS SDK)接口埋点
 * 埋点ID：triggerExpose_map_api
 * https://target.hellobike.cn/#/needs/buryingNeeds/detail?requirementId=7636
 */
export function ubtMapApi(_a) {
    var params = _a.params, response = _a.response, error = _a.error, startTime = _a.startTime, fetchOptions = _a.fetchOptions, status = _a.status;
    try {
        var ubt = getUBT();
        if (ubt) {
            var method = fetchOptions.method, context = fetchOptions.context, serviceType = fetchOptions.serviceType, mapOptions = fetchOptions.mapOptions;
            var Appkey = mapOptions.appKey, GdKey = mapOptions.key;
            // 从config中获取默认的高德key
            var gaodeKey = getGaoConfig().key;
            var lbsAppKey = getLbsConfig().appKey;
            var endTime = new Date().getTime();
            var serveSort = isArray(fetchOptions.serveSort)
                ? fetchOptions.serveSort
                : [ServiceTypeEnum.HELLO, ServiceTypeEnum.GAODE];
            var lbsSort = serveSort.toString();
            var rt = "".concat(endTime - context.startTime);
            var errorDesc = error ? error.message : '';
            var HlErrorCode = serviceType === ServiceTypeEnum.HELLO ? getErrorCode(response) : '';
            var GdErrorCode = serviceType === ServiceTypeEnum.GAODE ? getErrorCode(response) : '';
            var hlStartTime = getStartTimeHello({
                startTime: startTime,
                fetchOptions: fetchOptions,
                context: context,
            });
            var gdStartTime = getStartTimeGaode({
                startTime: startTime,
                fetchOptions: fetchOptions,
                context: context,
            });
            var sendMessage = {
                rt: rt,
                status: "".concat(status),
                lbsSort: lbsSort,
                errorDesc: errorDesc,
                HlErrorCode: HlErrorCode,
                GdErrorCode: GdErrorCode,
                hlStartTime: hlStartTime,
                gdStartTime: gdStartTime,
                lbsType: serviceType,
                method: method,
                startTime: "".concat(context.startTime),
                endTimeLength: "".concat(endTime),
                RequestInfo: JsonStringify(params),
                ResponseInfo: JsonStringify(response),
                Appkey: Appkey || lbsAppKey,
                GdKey: GdKey || gaodeKey,
                ApiName: method,
            };
            var trigger = {
                // `customEventWithPointId`不支持自定义`eventId`
                eventId: "map_api_".concat(sendMessage.method),
                pointId: 'triggerExpose_map_api',
                categoryId: 'ecoexpress',
                businessInfo: sendMessage,
            };
            mapLog('triggerExpose_map_api', [trigger]);
            // 兼容一下天启自定义埋点的新旧方法
            if (isFunction(ubt.customEventWithPointId)) {
                ubt.customEventWithPointId(trigger);
            }
            else if (isFunction(ubt.customEvent)) {
                ubt.customEvent(trigger);
            }
        }
    }
    catch (e) {
        mapError('(triggerExpose_map_api)上报异常', e);
    }
}
/**
 * dataType: 'text' 由于这个设置，返回的`data`是`string`
 * 会影响`trackHttp`上报成数据，`const { code, msg } = resData`，
 * 由于`resData`是`string`，解析会受到影响
 *
 * 所以这里将请求回调和`trackHttp`分开来处理
 * @param params
 */
export function getTrackParams(params) {
    return __assign(__assign({}, params), { 
        // @ts-ignore
        success: function (res) {
            // nothing
        }, 
        // @ts-ignore
        fail: function (res) {
            // nothing
        } });
}
/**
 * 如果`data`为`string`使用JSON.parse解析一下
 * @param res
 */
export function getTrackResponse(res) {
    try {
        if (res.data && isString(res.data)) {
            return __assign(__assign({}, res), { data: JSON.parse(res.data) });
        }
    }
    catch (e) {
        mapError('getTrackResponse', e);
    }
    return res;
}
//# sourceMappingURL=data:application/json;base64,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